









































































import { Component, Ref, Vue } from 'vue-property-decorator'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DialogoDeHistoricoDeErros from '@/components/layout/DialogoDeHistoricoDeErros.vue'

@Component({
	components: {
		DialogoDeHistoricoDeErros,
	},
})
export default class Help extends Vue{
	@Ref('historicoDeErros') historicoDeErros!: DialogoDeHistoricoDeErros

	icone = true
	version = process.env.PACKAGE_VERSION || ''
	menuAberto = false

	mostraSumario() {
		AppStore.setMostraSumarioDeTeclas(true)
	}

	mostraNovidades() {
		this.menuAberto = false
		if (this.$route.name === 'Novidades') return
		this.$router.push({ name: 'Novidades' }).catch(() => undefined)
	}

	/**
	 * O histórico de erros mora aqui, e não num sétimo ícone da barra, porque este menu já é o de
	 * "meta" do sistema (atalhos, novidades, versão) e é para cá que o Suporte vai mandar o cliente
	 * clicar.
	 */
	mostraHistoricoDeErros() {
		this.menuAberto = false
		this.historicoDeErros.mostrar()
	}

	get quantidadeDeErrosDeHoje() {
		return AlertModule.quantidadeDeErrosDeHoje
	}
}
